// Simple loader and executor for reCAPTCHA Enterprise (client-side token)
// Note: For real protection, validate the token server-side before accepting the action.

const SCRIPT_ID = 'recaptcha-enterprise-script';
const SCRIPT_SRC = 'https://www.google.com/recaptcha/enterprise.js';

function loadScript() {
  return new Promise((resolve, reject) => {
    if (typeof window === 'undefined') return resolve();
    if (window.grecaptcha && window.grecaptcha.enterprise) return resolve();
    let script = document.getElementById(SCRIPT_ID);
    if (!script) {
      script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.src = SCRIPT_SRC;
      script.async = true;
      script.defer = true;
      script.onerror = () => reject(new Error('Failed to load reCAPTCHA Enterprise script'));
      document.head.appendChild(script);
    }
    script.addEventListener('load', () => resolve());
  });
}

export async function getRecaptchaToken(action = 'LOGIN', siteKey) {
  const key = siteKey || (typeof process !== 'undefined' && process.env && process.env.REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY) || '6Lc7PO8rAAAAALb_xbeAQJt0qxid5YASCC9oF86P';
  await loadScript();
  if (!window.grecaptcha || !window.grecaptcha.enterprise) {
    throw new Error('reCAPTCHA Enterprise not available');
  }
  return new Promise((resolve, reject) => {
    try {
      window.grecaptcha.enterprise.ready(async () => {
        try {
          const token = await window.grecaptcha.enterprise.execute(key, { action });
          resolve(token);
        } catch (e) {
          reject(e);
        }
      });
    } catch (err) {
      reject(err);
    }
  });
}
